import React, { useEffect, useState } from "react";
import { noop } from "lodash";
import mediator from "@tvg/mediator";
import { Header, Modal, useTheme } from "@tvg/design-system";
import type { PreviousWinnersContainerProps } from "../../types";
import { MAX_WINNERS_HIGHLIGHT, ALL_WINNERS_INDEX } from "../../constants";
import PreviousWinnersList from "../PreviousWinnersList";
import {
  Container,
  UpperSection,
  LinkContainerDesk
} from "./styled-components";

const PreviousWinnersContainer: React.FC<PreviousWinnersContainerProps> = (
  props
) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const theme = useTheme();

  const allWinners = props.winners[ALL_WINNERS_INDEX];
  const totalWinners = allWinners.length;
  const hasUniqueWinner = totalWinners === 1;
  const winnersHighlighted = allWinners.slice(0, MAX_WINNERS_HIGHLIGHT);
  const showSeeAllElement = totalWinners > winnersHighlighted.length;

  // TODO: Remove this and control the visibility with the redux store
  useEffect(() => {
    mediator.base.subscribe("PREVIOUS_WINNERS:SEE_ALL", () => {
      setIsModalOpen(true);
    });
  }, []);

  const onSeeAllModalOpen = () => {
    mediator.base.dispatch({ type: "PREVIOUS_WINNERS:SEE_ALL" });
  };

  const onSeeAllModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <Container
      theme={theme}
      isDesktop={props.isDesktop}
      data-qa-label="previousWinnersContainer"
    >
      {props.isDesktop && (
        <UpperSection theme={theme} isDesktop={props.isDesktop}>
          <Header
            tag="h3"
            fontWeight="bold"
            data-qa-label="previousWinnersTitle"
          >
            {props.title}
          </Header>
          {showSeeAllElement && (
            <LinkContainerDesk
              theme={theme}
              onClick={onSeeAllModalOpen}
              data-qa-label="previousWinnersSeeAll"
            >
              See all
            </LinkContainerDesk>
          )}
        </UpperSection>
      )}
      <>
        <PreviousWinnersList
          isModal={false}
          isDesktop={props.isDesktop}
          winners={winnersHighlighted}
          hasUniqueWinner={hasUniqueWinner}
          showSeeAllElement={showSeeAllElement}
          onModalOpen={onSeeAllModalOpen}
          onSelection={props.onSelection}
        />
        <Modal
          type={props.isDesktop ? "lightbox" : "fullscreen"}
          title={props.modalTitle}
          isOpen={isModalOpen}
          onClose={onSeeAllModalClose}
          padding={0}
          hasBorderBottom={false}
        >
          <PreviousWinnersList
            isModal
            isDesktop={props.isDesktop}
            winners={allWinners}
            onModalOpen={noop}
            onSelection={props.onSelection}
          />
        </Modal>
      </>
    </Container>
  );
};

export default PreviousWinnersContainer;
